import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import products from "../../assets/store/products";
import ProductCard from "../../components/cards/ProductCard";
import Navbar from "../../components/navbar/Navbar";
import BrowseCollectionTopSection from "../../components/section/fillers/BrowseCollectionTopSection";
import ProductFilter from "../../components/section/filter/ProductFilter";
import Footer from "../../components/section/footer/Footer";
import MenuSpacer from "../../components/spacer/MenuSpacer";
import useIsMobile from "../../hooks/useIsMobile";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import { capitalizeFirstLetter } from "../../utils/TextTransformUtil";

const Wrapper = styled.div`
  position: relative;
`;

const Container = styled.div``;

const Intro = styled.div``;

const FilterSection = styled.div``;

const ItemsContainer = styled.div`
  display: grid;
  row-gap: 16px;
  column-gap: 4px;
  margin: 24px 40px;
  grid-template-columns: repeat(${({ $cols }) => $cols}, minmax(0, 1fr));

  @media (max-width: 950px) {
    margin: 24px 20px;
    gap: 8px;
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 200px;
  margin: 0 auto;
  gap: clamp(0.75rem, (16 / 1920) * 100vw, 1rem);

  span {
    letter-spacing: 0.08rem;
    font-size: ${fontSize.s};
    color: ${colors.primaryGray};
  }
`;

function BrowsePage() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const gridFromUrl = Number(queryParams.get("grid"));
  const categoryFromUrl = queryParams.get("category");

  const selectedCategory = categoryFromUrl || "all";

  console.log(selectedCategory);

  const allowedGrids = isMobile ? [1, 2] : [3, 4, 5];
  const defaultGrid = isMobile ? 1 : 4;
  const gridCols = allowedGrids.includes(gridFromUrl)
    ? gridFromUrl
    : defaultGrid;

  useEffect(() => {
    if (gridFromUrl !== gridCols) {
      navigate(`/browse?grid=${gridCols}&category=${selectedCategory}`, {
        replace: true,
      });
    }
  }, [gridCols, gridFromUrl, navigate, selectedCategory]);

  const filteredProducts =
    selectedCategory === "all"
      ? products
      : products.filter(
          (product) =>
            product.category === selectedCategory ||
            product.material
              .split(" ")
              .includes(capitalizeFirstLetter(selectedCategory))
        );

  const handleGridChange = (cols) => {
    navigate(`/browse?grid=${cols}&category=${selectedCategory}`);
  };
  return (
    <Wrapper>
      <Navbar />
      <MenuSpacer />
      <Container>
        <Intro>
          <BrowseCollectionTopSection />
        </Intro>
        <FilterSection>
          <ProductFilter
            total={filteredProducts.length}
            selectedGridOption={gridCols}
            onGridChange={handleGridChange}
          />
        </FilterSection>
        <ItemsContainer $cols={gridCols}>
          {filteredProducts.map((product) => (
            <ProductCard key={product.slug} product={product} />
          ))}
        </ItemsContainer>
        <PaginationContainer>
          <span>
            {filteredProducts.length} of {filteredProducts.length} PRODUCTS
          </span>
          {/* <PrimaryButton title="VIEW MORE" width="min(100%, 100%)" /> */}
        </PaginationContainer>
      </Container>
      <Footer />
    </Wrapper>
  );
}
export default BrowsePage;
